import { Button } from '@bambi/component-library/src/components/Button/Button';
import { CaretDownIcon, CaretUpIcon } from '@radix-ui/react-icons';
import { createColumnHelper } from '@tanstack/react-table';


export function getExpandableColumnDef<T>(columnHeaderWidth?: number) {
  const columnHelper = createColumnHelper<T>();
  return columnHelper.display({
    id: 'expand',
    enableHiding: false,
    meta: {
      enableHeaderMenu: false,
      headerWidth: columnHeaderWidth,
    },
    header: ({ table }) => (
      <Button
        onClick={table.getToggleAllRowsExpandedHandler()}
        variant="ghost"
        dataTestId="row-expander-header-button"
      >
        {table.getIsAllRowsExpanded() ? (
          <CaretUpIcon className="h-6 w-6" />
        ) : (
          <CaretDownIcon className="h-6 w-6" />
        )}
      </Button>
    ),
    cell: ({ row }) => {
      return (
        <Button variant="ghost" dataTestId="row-expander-button">
          {row.getIsExpanded() ? (
            <CaretUpIcon className="h-6 w-6" />
          ) : (
            <CaretDownIcon className="h-6 w-6" />
          )}
        </Button>
      );
    },
  });
}
